const GET_TIME_OFF_REQUESTS_REQUEST = 'GET_TIME_OFF_REQUESTS_REQUEST';
const GET_TIME_OFF_REQUESTS_SUCCESS = 'GET_TIME_OFF_REQUESTS_SUCCESS';
const GET_TIME_OFF_REQUESTS_FAILURE = 'GET_TIME_OFF_REQUESTS_FAILURE';
const UPDATE_TIME_OFF_REQUEST_STATUS_REQUEST = 'UPDATE_TIME_OFF_REQUEST_STATUS_REQUEST';
const UPDATE_TIME_OFF_REQUEST_STATUS_SUCCESS = 'UPDATE_TIME_OFF_REQUEST_STATUS_SUCCESS';
const UPDATE_TIME_OFF_REQUEST_STATUS_FAILURE = 'UPDATE_TIME_OFF_REQUEST_STATUS_FAILURE';
const EDIT_TIME_OFF_REQUEST_REQUEST = 'EDIT_TIME_OFF_REQUEST_REQUEST';
const EDIT_TIME_OFF_REQUEST_SUCCESS = 'EDIT_TIME_OFF_REQUEST_SUCCESS';
const EDIT_TIME_OFF_REQUEST_FAILURE = 'EDIT_TIME_OFF_REQUEST_FAILURE';
const ARCHIVE_TIME_OFF_REQUEST_REQUEST = 'ARCHIVE_TIME_OFF_REQUEST_REQUEST';
const ARCHIVE_TIME_OFF_REQUEST_SUCCESS = 'ARCHIVE_TIME_OFF_REQUEST_SUCCESS';
const ARCHIVE_TIME_OFF_REQUEST_FAILURE = 'ARCHIVE_TIME_OFF_REQUEST_FAILURE';
const MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_REQUEST = 'MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_REQUEST';
const MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_SUCCESS = 'MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_SUCCESS';
const MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_FAILURE = 'MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_FAILURE';

export default {
  GET_TIME_OFF_REQUESTS_REQUEST,
  GET_TIME_OFF_REQUESTS_SUCCESS,
  GET_TIME_OFF_REQUESTS_FAILURE,
  UPDATE_TIME_OFF_REQUEST_STATUS_REQUEST,
  UPDATE_TIME_OFF_REQUEST_STATUS_SUCCESS,
  UPDATE_TIME_OFF_REQUEST_STATUS_FAILURE,
  EDIT_TIME_OFF_REQUEST_REQUEST,
  EDIT_TIME_OFF_REQUEST_SUCCESS,
  EDIT_TIME_OFF_REQUEST_FAILURE,
  ARCHIVE_TIME_OFF_REQUEST_REQUEST,
  ARCHIVE_TIME_OFF_REQUEST_SUCCESS,
  ARCHIVE_TIME_OFF_REQUEST_FAILURE,
  MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_REQUEST,
  MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_SUCCESS,
  MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_FAILURE
};
